<template>
  <div class="pwc-event-register">
    <v-layout row class="pwc-register-row">
      <v-flex md6 hidden-xs-and-down class="pwc-register-image">
        <v-img height="100%" :src="cRandomBgUrl" aspect-ratio="1.7" />
      </v-flex>
      <v-flex md4 sm6 offset-md1 xs12 class="pwc-register-form" d-flex>
        <v-layout class="pwc-register-logo">
          <v-flex>
            <v-img :src="logo" style="width:230px; margin:auto;" />
          </v-flex>
        </v-layout>
        <v-layout justify-center class="pwc-register-title">
          <span>{{ cEventTitle }}</span>
        </v-layout>
        <div style="margin-top:100px; width:100%" />
        <transition-group name="list-complete">
          <v-text-field key="name" v-model="name" class="list-complete-item" single-line label="姓名" :rules="[rules.required]" />
          <v-select key="age" v-model="age" single-line class="list-complete-item" :items="lookups.ageRange" :rules="[rules.select]" item-text="name" item-value="id" label="年龄" :return-object="false" />
          <v-text-field key="email" v-model="email" class="list-complete-item" single-line label="邮箱" :rules="[rules.required, rules.email]" />
          <v-select
            key="educationOrWork"
            v-model="educationOrWork"
            single-line
            :rules="[rules.select]"
            class="list-complete-item"
            :items="educationOrWorkList"
            item-text="name"
            :return-object="false"
            item-value="id"
            label="在职状态"
          />
          <v-select
            v-if="cShowWorkInfo"
            key="yearofwork"
            v-model="yearsOfWork"
            single-line
            :rules="[rules.select]"
            class="list-complete-item"
            :items="lookups.workYearRange"
            item-text="name"
            :return-object="false"
            item-value="id"
            label="工作年限"
          />
          <v-select
            v-if="cShowWorkInfo"
            key="industryId"
            v-model="industryId"
            class="list-complete-item"
            :items="lookups.industries"
            single-line
            label="行业"
            item-text="name"
            item-value="id"
            :rules="[rules.select]"
            :return-object="false"
          />
          <v-text-field v-if="cIndustry === '其他'" key="industryOther" v-model="industryOther" class="list-complete-item" :rules="[rules.required]" single-line label="其他行业" />
          <v-text-field v-if="cShowWorkInfo" key="company" v-model="company" class="list-complete-item" :rules="[rules.required]" single-line label="公司" />
          <v-text-field v-if="cShowWorkInfo" key="title" v-model="title" class="list-complete-item" :rules="[rules.required]" single-line label="职位" />
          <v-text-field v-if="cShowEducation" key="school" v-model="eduInstitution" class="list-complete-item" :rules="[rules.required]" single-line label="学校" />
          <v-select
            v-if="cShowEducation"
            ref="grade"
            key="grade"
            v-model="grade"
            single-line
            :rules="[rules.required]"
            :items="lookups.anchorStudentGrades"
            item-text="name"
            item-value="id"
            class="list-complete-item"
            label="年级"
          />
          <v-text-field v-if="cShowEducation" key="major" v-model="major" class="list-complete-item" :rules="[rules.required]" single-line label="专业" />
          <v-text-field v-if="cShowWorkInfo" key="RefererId" v-model="RefererId" class="list-complete-item" single-line label="推荐人ID" />
          <v-text-field v-if="cShowWorkInfo" key="RefererName" v-model="RefererName" class="list-complete-item" single-line label="推荐人姓名" />
        </transition-group>
        <v-container v-if="cShowWorkInfo && isRequiredCv === 'true'" style="margin-top: -20px;">
          <v-layout row>
            <v-flex xs12>
              <v-card>
                <div style="height: 120px; display:flex;justify-content:center;lign-items:center; padding-top:20px;">
                  <v-chip v-model="hasFile" close color="orange" label outline @input="removFile" @click="downLoad">{{ fileName }}</v-chip>
                  <v-btn v-if="!hasFile" color="blue-grey" class="white--text" @click="uploadInputClick">
                    上传简历,赢取名师点评
                    <v-icon right dark>fas fa-cloud-upload-alt</v-icon>
                  </v-btn>
                </div>
                <input id="upload" ref="uploadInput" type="file" accept=".doc, .docx, .pdf" @change="changeimg">
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-layout row class="pwc-form-action">
          <v-flex xs12>
            <v-btn block color="#d04a02" :disabled="disableRegister" depressed @click="handleSave">{{ cLoginButtonText }}</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- dialog -->
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-text>
          {{ dialogText }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="#d04a02" flat="flat" @click="dialog = false"> 确定 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading.userInfoLoading" persistent light width="120px">
      <v-card class="pwc-loading">
        <v-progress-circular indeterminate color="#fff" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { validRequired, validEmail, validRequiredSelect } from '@/util/validation'
import { next } from '@/mixin/index'
import logo from '@/assets/logo.png'
import { logic } from '../common/mixin/logic'

import { mapActions } from 'vuex'
import { upload } from '@/mixin/file'
import { loading } from '@/mixin'
import Actions from '@/constants/action'
// image
import img_0 from '@/assets/event-bg-0.jpg'
import img_1 from '@/assets/event-bg-1.jpg'
import img_2 from '@/assets/event-bg-2.jpg'
import img_3 from '@/assets/event-bg-3.jpg'
const educationOrWorkList = [{ id: 0, name: '在校学生' }, { id: 1, name: '职场人士' }]

export default {
  mixins: [next, logic, upload, loading],
  data() {
    return {
      dialog: false,
      dialogText: '',
      rules: {
        required: validRequired,
        email: validEmail,
        select: validRequiredSelect
      },
      disableRegister: true,
      eventName: this.$route.query.name,
      logo,
      hasFile: false,
      fileName: '',
      fileUrl: '',
      fixedFileName: '',
      educationOrWorkList
    }
  },
  computed: {
    cRandomBgUrl() {
      const imgList = [img_0, img_1, img_2, img_3]
      return imgList[Date.now() % 4]
    },
    cLoginButtonText() {
      return '注册活动'
    },
    // educationOrWork() {
    //   return Number(this.programmeType)
    // },
    cEventTitle() {
      return this.eventName || '请完善个人信息'
    },
    cIndustry: {
      get() {
        const obj = (this.lookups.industries || []).find(v => v.id === this.industryId)
        if (obj) {
          return obj.name
        }
        return this.industryId
      },
      set(n) {
        this.industryId = n
      }
    }
  },
  methods: {
    ...mapActions({
      updateResume: Actions.UPDATE_RESUME
    }),
    handleCheck() {
      const cICheck = this.cIndustry === '其他'
      const YPCheck = this.cShowWorkInfo && (!this.yearsOfWork || !this.company || !this.title || !this.industryId || (cICheck && !this.industryOther))
      const ACCheck = this.cShowEducation && (!this.eduInstitution || !this.grade || !this.major)
      if (!this.name || !this.age || !this.email || !this.educationOrWork.toString() || validEmail(this.email) !== true || YPCheck || ACCheck) {
        this.disableRegister = true
      } else {
        this.disableRegister = false
      }
      // if (!this.name || !this.email || validEmail(this.email) !== true || !this.yearsOfWork || !this.age || !this.company || !this.title) {
      //   this.disableRegister = true
      // } else {
      //   this.disableRegister = false
      // }
    },
    handleDialogMessage(message) {
      if (message) {
        this.dialogText = message
        this.dialog = true
      }
    },
    uploadInputClick() {
      const uploadbtn = this.$refs.uploadInput
      uploadbtn.click()
    },
    async changeimg(e) {
      const accept = '.pdf,.doc,.docx'

      const flieArr = e.name.split('.')
      const suffix = flieArr[flieArr.length - 1] || ''

      if (!accept.includes(suffix.toLowerCase())) {
        this.$dialog.alert({
          message: '只有pdf，doc，docx格式文档允许被上传',
          confirmButtonText: 'OK'
        })
        return false
      }

      this.uploading = true
      const res = await this.uploadFile(e, '', false).then(key => {
        return this.updateResume({
          item: key,
          isDelete: 0
        })
      })

      this.fixedFileName = encodeURI(e.target.files[0].name)
      this.fileUrl = res.data.resumes
      this.uploading = false

      this.fileName = e.target.files[0].name
      this.hasFile = true
    },
    removFile() {
      this.updateResume({
        item: this.fixedFileName,
        isDelete: 1
      })
      this.hasFile = false
      this.fixedFileName = ''
      this.fileUrl = ''
      this.fileName = ''
    },
    downLoad() {
      if (this.fileUrl) {
        window.open(this.fileUrl)
      } else {
        this.handleDialogMessage('文件丢失，请重新上传')
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>

<style lang="scss">
#upload {
  height: 0;
  width: 0;
  visibility: hidden;
}
.pwc-event-register {
  .v-text-field {
    padding-top: 0;
    margin-top: 0;
  }
  .layout.row {
    width: 100%;
  }
  .v-btn {
    margin: auto;
    max-width: 230px;
  }
  .v-btn__content {
    color: #fff;
  }
  .v-messages__message {
    color: red;
  }
  .theme--light.error--text > .v-input__control > .v-input__slot:before {
    border-color: red;
  }
}
</style>
